import React from "react";

import DynamicTable from "@Components/shared/DynamicTable";
import { IColumnData } from "@Utils";
import { Card, Col, Row, Segmented, Typography } from "antd";
import { ICertificateTableData } from "./types";

const { Text, Title } = Typography;

interface IExistingCertificatesTableProps {
    columnData: IColumnData<ICertificateTableData>[];
    dataSource: ICertificateTableData[];
    isFetched: boolean;

    /** Query Flag for when data is fetching */
    isFetching: boolean;

    /** Query flag for when data is loading */
    isLoading: boolean;

    onFilterChange?: (pointsType: string) => void;
}

/**
 * A table that displays existing CPD and CME certificates
 */
const ExistingCertificatesTable = ({
    columnData,
    dataSource,
    isFetched,
    isFetching,
    isLoading,

    onFilterChange,
}: IExistingCertificatesTableProps) => {
    const isShowingFiler = onFilterChange !== undefined;

    return (
        <div className="existing-certificates">
            <Row>
                <Col span={8}>
                    <Title level={3} style={{ width: "100%" }}>
                        Existing Certificates
                    </Title>
                </Col>
                {isShowingFiler ? (
                    <Col span={8}>
                        <Segmented
                            options={[
                                { label: <Text strong>Show all</Text>, value: "all" },
                                { label: <Text strong>CME Points</Text>, value: "cme" },
                                { label: <Text strong>CPD Points</Text>, value: "cpd" },
                            ]}
                            onChange={(e) => onFilterChange(String(e))}
                        />
                    </Col>
                ) : null}
            </Row>
            <Row>
                <Col xs={24}>
                    <Card className="newUI-subtle" style={{ marginTop: "20px" }}>
                        <Card.Grid className="full-width" hoverable={false}>
                            <DynamicTable
                                dataSource={dataSource}
                                columnData={columnData}
                                isLoading={!isFetched || isLoading}
                                isFetching={isFetching}
                                pagination={{ pageSize: 5, position: ["bottomCenter"] }}
                                rowKey="pointsMetadataId"
                            />
                        </Card.Grid>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default ExistingCertificatesTable;
